import {Component, OnInit, Input, ViewChild, ElementRef} from '@angular/core';
import {KlaHttpService} from "../services/kla.http.service";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'kla-audio',
  templateUrl: './audio.component.html',
  styleUrls: ['./audio.component.scss'],
  standalone: true,
  imports: [ CommonModule ]
})
export class AudioComponent implements OnInit {

  @Input()
  public url: string;

  @Input()
  public image: string;

  @Input()
  public text: string;

  @ViewChild('player', {static: true})
  public player:ElementRef;

  public progress: number = 0;
  public progressEnabled: boolean = false;
  public imagePath:string;

  constructor(private httpService: KlaHttpService) {}

  ngOnInit() {
    this.imagePath = this.httpService.getImagePath(this.image, 100);
  }

  progressValidation() {
    if (this.progressEnabled) {
      this.progressEnabled = false;
    } else {
      this.updateProgress();
      this.progressEnabled = true;
    }
  }

  private updateProgress() {
    let duration = this.player.nativeElement.duration;
    let currentTime = this.player.nativeElement.currentTime;
    duration = duration ? duration : 100;
    currentTime = currentTime ? currentTime : 0;
    this.progress = currentTime*100/duration;
    if (this.progressEnabled) {
      setTimeout(() => {
        this.updateProgress();
      }, 500)
    }
  }
}
